export const quizCopy = {
	$title: 'What kind of super are you?',
	$scrollPrompt: 'Scroll to find your new home',
	$enterName: 'Enter your hero name',
	$nameExample: 'ex: QUEEN MAEVE',
	$selectPower: 'Select your superpower',
	$startExam: 'Start your exam',
	$profanityError: 'This is a prestigious, family-friendly university. Please try again, this time with decorum.',
	$existingCharacterError: 'This sounds familiar... We encourage originality in our students!',
	$back: 'Back',
	$welcomeToGodU: 'Welcome to Godolkin University',
	$completeReg: 'To complete student ID generation, take or upload a photo',
	$takePhoto: 'Take a photo',
	$enableCamera: 'Please enable camera to take a photo.',
	$upload: 'Upload',
	$picTipHeader: 'Tips for super photos:',
	$picTip1: 'Use good lighting',
	$picTip2: 'Take against a high contrast background',
	$capture: 'Capture',
	$resize: 'Resize',
	$pinchToZoom: 'Pinch to zoom',
	$zoom: 'Zoom',
	$rotateFingers: 'Rotate with 2 fingers',
	$rotate: 'Rotate',
	$retake: 'Retake photo',
	$continue: 'Continue',
	$loading: 'Loading...',
	$tapAndHold: 'Tap and hold to save',
	$share: 'Share',
	$download: 'Save image',
	$feed: 'Feed',
	$stories: 'Stories',
	$godU: 'Godolkin University',
	$studentIdCard: 'Student Identity Card',
	$name: 'Name',
	$power: 'Power',
	$major: 'Major',
	$crimefighting: 'crimefighting',
	$performingArts: 'Performing Arts',
	$browserNotSupportedTitle: 'Unfortunately this browser is not supported',
	$browserNotSupportedMessage: 'To view this site please use one of the following browsers:',
	$backToHome: 'Back to home',
	$deviceReqTitle: 'To use this experience at its best you\'ll need',
	$ios: 'iOS',
	$iosReqs: [
		'Latest software update (iOS 16.3)',
		'iPhone 7/ iPad 5 or newer',
		'Have a rear camera',
		'Open this page in Safari'
	],
	$android: 'Android',
	$androidReqs: [
		'Android 7 or newer',
		'Have a rear camera',
		'Open this page in Chrome'
	],
	$cameraAccessDeniedTitle: 'Camera access is required for this experience',
	$cameraAccessDeniedMessage: 'You can grant permissions for this experience to access your device camera via your device settings menu.',
	$cameraAccessDeniedMessageDesktop: 'You can grant permissions for this experience to access your device camera via your browser settings menu.',
	$turnDevice: 'Turn your device to',
	$portraitMode: 'Portrait mode',
	$socialShareCopy: 'It\'s official – I\'m going to God U this fall! Get your student ID at'
};